// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__28EaC","col":"Table_col__2GRyi","fulfillmentStatus":"Table_fulfillmentStatus__2Yfxk","emailCol":"Table_emailCol__3xoM1"};